module.exports = function(app) {
	'use strict';
	app.directive('eprChangeProviders', function() {
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/assistEmployees/eprChangeProviders.html'),
			scope: {
				provider: '=eprChangeProviders',
				employee: '=',
				editMode: '=?'
			},
			controller: ['$state', '$scope', 'modal', function ($state, $scope, modal) {
				// Select All Checkboxes
				$scope.checkAll = function () {
					if ($scope.selectedAll) {
						$scope.selectedAll = false;
					}
					else {
						$scope.selectedAll = true;
					}
					angular.forEach($scope.employee.data.dependents, function (person) {
						person.selected = $scope.selectedAll;
					});
				};
				// Modal Submit for Providers
				$scope.submitCopy = function () {

					var selectedParticipantList = [];

					for (var i = 0; i < $scope.employee.data.dependents.length; i++) {
						if ($scope.employee.data.dependents[i].selected) {
							selectedParticipantList.push($scope.employee.data.dependents[i]);
						}
					}
					$scope.copyData($scope.selectedPerson, selectedParticipantList);
					$scope.selectedAll = false;
					modal.close();
				};

				// Modal Close Button for Providers
				$scope.closeModel = function () {
					$scope.selectedAll = false;
					modal.close();
				};

			}]
		};
	});
};
